import request from "root/js/request";

// фильтрацию по данным сделали на фронте, поэтому не передаем параметры в запросе
export const getPromoPartners = async () => {
  const response = await request({
    url: `/promo_partners/`,
    method: "get",
  });
  return response.data;
};
